import { action, payload } from 'ts-action'
import { IShift } from 'models/Shift'
import { IError, IPayload } from 'models/Global'

export const GetActiveShifts = action('GetActiveShifts', payload<IPayload<IShift[]>>())

export const GetActiveShiftsErrors = action('GetActiveShiftsErrors', payload<IError>())

export const ActiveShiftsFetching = action('ActiveShiftsFetching', payload<boolean>())
